import React from 'react';
import {Link} from "react-router-dom";

const PrivacyPolicyPage = () => {
  const contactMail = "info@ekovaruh.si";

  return (
    <div className="privacy-policy-page content">
      <h1>Privacy Policy</h1>
      <section>
        <p><strong>Eko Varuh</strong> is committed to protecting your privacy. This Privacy Policy outlines how we
          collect, use, and safeguard your information when you use our app, which helps track and report illegal
          dumping sites.</p>
      </section>

      <hr/>

      <section>
        <h2>1. Information We Collect</h2>
        <h3>1.1 Account Information</h3>
        <ul>
          <li>Email address</li>
          <li>Password</li>
          <li>Full name</li>
          <li>Company name</li>
        </ul>

        <h3>1.2 Location Data</h3>
        <p>We collect your location:</p>
        <ul>
          <li>When you enable location services, to display nearby illegal dumping sites and show your position on the
            map. In this case location is not stored.
          </li>
          <li>When you create a report of an illegal dumping site, or update location of existing one to determine the location of the site.</li>
        </ul>

        <h3>1.3 Photos</h3>
        <p>You can upload photos of illegal dumping sites as part of your reports. These photos are stored securely.</p>

      </section>

      <hr/>

      <section>
        <h2>2. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Provide, operate, and improve the Eko Varuh app.</li>
          <li>Display illegal dumping sites on the map and in lists.</li>
          <li>Facilitate the reporting of new illegal dumping sites.</li>
          <li>Communicate with you regarding updates, issues, or new features.</li>
          <li>Ensure compliance with our Terms of Use.</li>
        </ul>
      </section>

      <hr/>

      <section>
        <h2>3. Sharing of Your Information</h2>
        <p>We do not sell, rent, or trade your personal information. We may share your information in the following
          cases:</p>
        <ul>
          <li><strong>With service providers:</strong> Third parties who assist us in app operations, under strict
            confidentiality agreements.
          </li>
          <li><strong>Legal compliance:</strong> When required by law or to respond to legal processes.</li>
          <li><strong>To protect rights:</strong> To enforce our Terms of Use or protect our users or others from harm.
          </li>
        </ul>
      </section>

      <hr/>

      <section>
        <h2>4. Data Retention</h2>
        <p>We retain your personal information as long as your account is active or as needed to provide the app's
          services. If you delete your account, we will remove your personal data except for data required by law or
          necessary to maintain app integrity (e.g., reports already submitted).</p>
      </section>

      <hr/>

      <section>
        <h2>5. Your Privacy Choices</h2>
        <ul>
          <li><strong>Location Services:</strong>
            <p>You can disable location services at any time through your device settings. However, certain features may
              not work without location data.</p>
          </li>
          <li><strong>Profile Information:</strong>
            <p>You can update or delete your company name and other profile details within the app.</p>
          </li>
          <li><strong>Account Deletion:</strong>
            <p>You can delete your account <Link to="/delete-account">Here</Link>.
              By deleting your account, your name and surname will still be stored and visible for illegal dumping
              locations that you have created or edited.</p>
          </li>
          <li>
            <strong>Data Deletion:</strong>
            <p>You may request deletion of all your data by contacting us at <a
              href={`mailto:${contactMail}`}>{contactMail}</a>.</p>
          </li>
        </ul>
      </section>

      <hr/>

      <section>
        <h2>6. Data Security</h2>
        <p>We implement industry-standard security measures to protect your data. However, no system is entirely secure,
          and we cannot guarantee absolute security.</p>
      </section>

      <hr/>

      <section>
        <h2>7. Changes to This Privacy Policy</h2>
        <p>We may update this Privacy Policy to reflect changes in our practices or legal requirements. We will notify
          you of significant updates through the app or via email. Your continued use of the app signifies acceptance of
          the updated Privacy Policy.</p>
      </section>

      <hr/>

      <section>
        <h2>8. Contact Us</h2>
        <p>If you have any questions or concerns about this Privacy Policy or your data, please contact us at:</p>
        <ul>
          <li><strong>Email:</strong> <a href={`mailto:${contactMail}`}>{contactMail}</a></li>
          <li><strong>Address:</strong> Result d.o.o., Celovška 182, Ljubljana, Slovenia</li>
        </ul>
      </section>

      <br/>
      <footer>
        <p>Thank you for using Eko Varuh to help keep our environment clean!</p>
      </footer>
    </div>
  );
}

export default PrivacyPolicyPage;